const i = (o) => o, s = (o, t, n) => t(o) ? n(o) : void 0, c = (o, t) => o ? t() : void 0, e = (o, t) => c(o, () => t), d = (o, t, n, r) => {
  if (t(o))
    return n(o);
  throw r();
}, f = (o, t) => (n) => t(o(n));
export {
  f as compose,
  c as evalIfTrue,
  i as identity,
  e as ifTrue,
  d as mapGuardOrFail,
  s as mapIf
};
//# sourceMappingURL=utils.js.map
